module.exports = __webpack_public_path__ + "img/protect_big.81546bc2.jpg";